import React from 'react';
import type { DatePickerProps } from 'antd';

import StyledDatePicker from './styled.tsx';

export const BaseDatePicker: React.FC<DatePickerProps> = (props) => <StyledDatePicker {...props} />;
